import React from 'react';
import { Chart } from '../Chart';

const chartOptions = {
  cutout: '40%',
  aspectRatio: 1.5,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    crosshair: {
      display: false,
    }
  }
};

const AlarmsDoughnut = (props) => (
  <Chart
    type="doughnut"
    data={props.data}
    options={chartOptions}
  />
);

export default AlarmsDoughnut;
